import { createAction } from '@reduxjs/toolkit';

import { MonogramProps } from '@definitions/monogram.types';

const PREFIX = 'MONOGRAM';

export const clearMonogram = createAction<number>(`${PREFIX}/CLEAR_MONOGRAM`);
export const addMonogram = createAction<MonogramProps>(`${PREFIX}/ADD_MONOGRAM`);
